<template>
    <div>
        <v-layout row wrap xs12>
            <!-- debut dialog -->
            <v-dialog v-model="dialog" max-width="70%">
                <template v-slot:activator="{ on }">
                    <v-layout class="btn-dialog" align-start justify-end>
                        <v-btn 
                            v-show="!$storeDemandeBourse.ReadOnly"
                            dark 
                            v-on="on"
                            color="secondary">
                            Ajouter
                        </v-btn>
                    </v-layout>
                </template>
                <v-form
                ref="form"
                v-model="valid">
                    <v-card>
                        <v-toolbar color="secondary" dark>
                            <v-toolbar-title>Ajouter concours</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-container grid-list-md>
                                    <v-row v-show="$storeDemandeBourse.DonneesFormulaire.Programmes.indexOf($storeCatalogue.ProgrammeGemDataId) !== -1">
                                        <v-col cols="6">
                                            <v-autocomplete
                                            label="Concours Marocain ou Français ?"
                                            v-model="editedItem.FrancaisOuMarocain"
                                            item-text="lang00"
                                            item-value="id"
                                           :items="Concours"
                                           :rules="$storeDemandeBourse.DonneesFormulaire.Programmes.indexOf($storeCatalogue.ProgrammeGemDataId) !== -1 ? $storeReglesBourse.obligatoire : []"
                                            />
                                        </v-col>
                                        <v-col cols="6">
                                        </v-col>
                                    </v-row>
                                    <v-row v-show="editedItem.FrancaisOuMarocain == 1 || $storeDemandeBourse.DonneesFormulaire.Programmes.indexOf($storeCatalogue.ProgrammeGemDataId) == -1">
                                        <v-col cols="6">
                                            <v-autocomplete
                                                label="Concours Français"
                                                v-model="editedItem.ConcoursFrancais"
                                                item-text="lang00"
                                                item-value="id"
                                                :items="$storeCatalogue.ConcoursFr"
                                                clearable
                                                @change="ConcoursFranceChange()"
                                                :rules="editedItem.FrancaisOuMarocain == 1 || $storeDemandeBourse.DonneesFormulaire.Programmes.indexOf($storeCatalogue.ProgrammeGemDataId) == -1 ? $storeReglesBourse.obligatoire : []"
                                            ></v-autocomplete>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-autocomplete
                                                label="Ecole"
                                                v-model="editedItem.EcoleFrancaise"
                                                item-text="lang00"
                                                item-value="id"
                                                :items="$storeCatalogue.EcoleFrAffiche"
                                                clearable
                                                :rules="editedItem.FrancaisOuMarocain == 1 || $storeDemandeBourse.DonneesFormulaire.Programmes.indexOf($storeCatalogue.ProgrammeGemDataId) == -1 ? $storeReglesBourse.obligatoire : []"
                                            ></v-autocomplete>
                                        </v-col>
                                    </v-row>
                                    <v-row v-show="editedItem.FrancaisOuMarocain == 2">
                                        <v-col cols="6">
                                            <v-autocomplete
                                                label="Concours Marocain"
                                                v-model="editedItem.ConcoursMarocain"
                                                item-text="lang00"
                                                item-value="id"
                                                :items="$storeCatalogue.ConcoursMa"
                                                clearable
                                                :rules="editedItem.FrancaisOuMarocain == 2 ? $storeReglesBourse.obligatoire : []"
                                                @change="ConcoursMarocChange()"
                                            ></v-autocomplete>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-autocomplete
                                                label="Ecole"
                                                v-model="editedItem.EcoleMarocaine"
                                                item-text="lang00"
                                                item-value="id"
                                                :items="$storeCatalogue.EcoleMaAffiche"
                                                clearable
                                                :rules="editedItem.FrancaisOuMarocain == 2 ? $storeReglesBourse.obligatoire : []"
                                            ></v-autocomplete>
                                        </v-col>
                                    </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn small dark color="secondary" @click="close">Annuler</v-btn>
                            <v-btn small dark color="secondary" @click="save">Valider</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
            <!-- fin dialog -->
        </v-layout>
        <!-- Début Liste langues -->
        <v-data-table :headers="headers" :items="$storeDemandeBourse.DonneesFormulaire.ListeConcoursCibles" class="elevation-1" disable-pagination hide-default-footer>
            <template v-slot:item={item}>
                <tr v-if="!item.Supprimer">
                    <th v-show="item.FrancaisOuMarocain == 1 || $storeDemandeBourse.DonneesFormulaire.Programmes.indexOf($storeCatalogue.ProgrammeGemDataId) == -1" class="text-xs-left">
                        {{ $storeCatalogue.AffichageCatalogue($storeCatalogue.ConcoursFr, item.ConcoursFrancais, $storeCommun.ItemLang) }}
                    </th>
                    <th v-show="item.FrancaisOuMarocain == 1 || $storeDemandeBourse.DonneesFormulaire.Programmes.indexOf($storeCatalogue.ProgrammeGemDataId) == -1" class="text-xs-left">
                        {{ $storeCatalogue.AffichageCatalogue($storeCatalogue.EcoleFr, item.EcoleFrancaise, $storeCommun.ItemLang) }}
                    </th>

                    <th v-show="item.FrancaisOuMarocain == 2" class="text-xs-left">
                        {{ $storeCatalogue.AffichageCatalogue($storeCatalogue.ConcoursMa, item.ConcoursMarocain, $storeCommun.ItemLang) }}
                    </th>
                    <th v-show="item.FrancaisOuMarocain == 2" class="text-xs-left">
                        {{ $storeCatalogue.AffichageCatalogue($storeCatalogue.EcoleMa, item.EcoleMarocaine, $storeCommun.ItemLang) }}
                    </th>
                    <th>
                        <v-icon small class="mr-2" @click="editItem(item)" v-show="!$storeDemandeBourse.ReadOnly">{{ icons.mdiPencil }}</v-icon>
                        <v-icon small @click="deleteItem(item)" v-show="!$storeDemandeBourse.ReadOnly">{{ icons.mdiDelete }}</v-icon>
                    </th>
                </tr>
            </template>
        </v-data-table>
    </div>
</template>
<script>
    import {
        mdiPencil,
        mdiDelete,
    } from '@mdi/js'
    export default {
        components: {},
        data() {
            return {
                // Icon importés depuis mdi/js pour les icones d'édition/suppression
                  icons: {
                    mdiPencil,
                    mdiDelete,
                },
                // Réaffecter l'objet global pour forcer la maj en temps réel
                $storeCatalogue: this.$storeCatalogue,
                $storeDemandeBourse: this.$storeDemandeBourse,
                $storeReglesBourse: this.$storeReglesBourse,
                $storeCommun : this.$storeCommun,
                // dialog pour ouvrir/fermer la popup
                dialog: false, 

                // Validation du formulaire
                valid : false, 
                
                // Catalogue local
                Concours:[
                    {
                        id:1,
                        lang00:'Français'
                    },
                    {
                        id:2,
                        lang00:'Marocain'
                    },
                ],

                // nom des colonnes
                headers: [
                    { text: 'Concours', value: 'concours' },
                    { text: 'Ecole', value: 'ecole' },
                    { text: '', value: 'actions', sortable: false }
                ],

                // index de l'objet édité.
                editedIndex: -1,

                // Item local
                editedItem: {
                    IdCrypte:null,
                    FrancaisOuMarocain:null,
                    Supprimer:false,
                    ConcoursFrancais:null,
                    ConcoursMarocain:null,
                    EcoleFrancaise:null,
                    EcoleMarocaine:null,
                },
            }
        },
        created(){
            if(this.$storeDemandeBourse.DonneesFormulaire.Programmes.indexOf(this.$storeCatalogue.ProgrammeGemDataId) !== -1){
                this.headers=[
                    { text: 'Concours', value: 'concours' },
                    { text: 'Ecole', value: 'ecole' },
                    { text: '', value: 'actions', sortable: false }
                ]
            }
            else {
                this.headers=[
                    { text: 'Concours', value: 'concours' },
                    { text: 'Ecole', value: 'ecole' },
                    { text: '', value: 'actions', sortable: false }
                ]
            }
        },
        methods: {
            ConcoursMarocChange(){
                this.editedItem.EcoleMarocaine = null;
                this.$storeCatalogue.EcoleMaAffiche = this.$storeCatalogue.EcoleMa.filter(item=>{
                   return item.parentId == this.editedItem.ConcoursMarocain;
                });
            },
            ConcoursFranceChange(){
                this.editedItem.EcoleFrancaise = null;
                this.$storeCatalogue.EcoleFrAffiche = this.$storeCatalogue.EcoleFr.filter(item=>{
                   return item.parentId == this.editedItem.ConcoursFrancais;
                });
            },
            editItem(item) {
                // Vide les infos du concours FR si le type de concours est marocain, et inversement
                if(this.editedItem.FrancaisOuMarocain == 2){
                    this.editedItem.ConcoursFrancais = null;
                    this.editedItem.EcoleFrancaise = null;
                } 
                else if(this.editedItem.FrancaisOuMarocain == 1){
                    this.editedItem.ConcoursMarocain = null;
                    this.editedItem.EcoleMarocaine = null;
                }

                // Récupère l'item à éditer et l'affecte à editItem local pour remplir les rubriques du formulaire popup.
                this.editedIndex = this.$storeDemandeBourse.DonneesFormulaire.ListeConcoursCibles.indexOf(item)
                this.editedItem = Object.assign({}, item)

                // ouvre le popup
                this.dialog = true
            },
            deleteItem(item) {
                if (confirm("Etes-vous sûr de vouloir supprimer cette ligne?")) {
                    // on récupère l'item depuis le store
                    this.editedIndex = this.$storeDemandeBourse.DonneesFormulaire.ListeConcoursCibles.indexOf(item)
                    // on affecte l'item local pour récupèrer les valeurs
                    this.editedItem = Object.assign({}, item)

                    // on affecte la valeur supprimer à true
                    this.editedItem.Supprimer = true;

                    // on modifie l'item dans le store
                    Object.assign(this.$storeDemandeBourse.DonneesFormulaire.ListeConcoursCibles[this.editedIndex], this.editedItem)

                    // appel le close pour désaffecter l'item local
                    this.close();
                }
            },
            close() {
                // RAZ des champs du formulaire
                this.$refs.form.resetValidation();
                // ferme le popup
                this.dialog = false
                // on remet à zéro le editedItem local
                this.editedItem = Object.assign({}, {
                    IdCrypte:null,
                    FrancaisOuMarocain:null,
                    Supprimer:false,
                    ConcoursFrancais:null,
                    ConcoursMarocain:null,
                    EcoleFrancaise:null,
                    EcoleMarocaine:null,
                });

                this.editedIndex = -1;
            },
            save() {
                // validation du formulaire
                this.$refs.form.validate();
                if(!this.valid){
                    return;
                }

                // on passe le item local à false.
                this.editedItem.Supprimer = false;
                
                // Vide les infos du concours FR si le type de concours est marocain, et inversement
                if(this.editedItem.FrancaisOuMarocain == 2){
                    this.editedItem.ConcoursFrancais = null;
                    this.editedItem.EcoleFrancaise = null;
                } 
                else if(this.editedItem.FrancaisOuMarocain == 1){
                    this.editedItem.ConcoursMarocain = null;
                    this.editedItem.EcoleMarocaine = null;
                }

                // on modifie l'item dans le store si l'editedIndex est renseigné.
                if (this.editedIndex > -1) {
                    Object.assign(this.$storeDemandeBourse.DonneesFormulaire.ListeConcoursCibles[this.editedIndex], this.editedItem)
                }
                // sinon, on ajoute l'item local au store.
                else {
                    this.$storeDemandeBourse.DonneesFormulaire.ListeConcoursCibles.push(this.editedItem)
                }

                // on appelle close pour raz l'item local + fermer le popup
                this.close();
            },
        },
    }
</script>
<style scoped src="@/assets/css/DemandeBourse.css">
</style>